<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex justify-between my-3">
  <h2>View Roles</h2>
  <button *appHasAnyPrivilege="'ROLE_CREATE'" nz-button nzType="primary" (click)="goto()">Update Role</button>
</div>
<nz-card class="table-card">
  <div [ngClass]="loading ? 'hidden' : 'block'" class="table-obj">
    <nz-table #basicTable [nzData]="rolesData"
              [nzShowSizeChanger]="pageSize.length > 5"
              [nzPageSizeOptions]="pageSize.pageSizeOptions"
              [nzPageSize]="pageSize.pageSize"
              [nzPageIndex]="pageSize.pageIndex"
              [nzFrontPagination]="false"
              [nzTotal]="pageSize.length"
              (nzQueryParams)="onTableParamsChange($event)"
              [nzScroll]="{ x: 'auto', y: '550px' }"
              nzTableLayout="fixed"
              nzOuterBordered>
      <thead>
      <tr>
        <th style="white-space: nowrap;">Role Name</th>
        <th style="white-space: nowrap;">Permissions</th>
        <th style="white-space: nowrap;">Users</th>
        <th style="white-space: nowrap;">
          <div class="flex">
            <span>Created Date</span>
            <span *ngIf="sortOrder === -1" nz-icon nzType="up" nzTheme="outline"
                  class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
          </span>
            <span *ngIf="sortOrder === 1" nz-icon nzType="down" nzTheme="outline"
                  class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
          </span>
          </div>
        </th>
        <th style="white-space: nowrap;" *ngIf="hasAccessToPerformAction()">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let data of basicTable.data">
        <td style="white-space: nowrap; min-width: 150px; ">{{ data.name | titlecase }}</td>
        <td style="white-space: nowrap; min-width: 150px;">{{ data.permissions }}</td>
        <td style="white-space: nowrap;min-width: 150px;">{{ data.users }}</td>
        <td style="white-space: nowrap; min-width: 150px;">{{ data.createdAt | date: 'dd-MM-y' }}</td>
        <td style="white-space: nowrap;" *ngIf="hasAccessToPerformAction()">
          <div class="flex justify-start">
            <button *appHasAnyPrivilege="'ROLE_UPDATE'" class="mr-2" nz-button nzType="default" [class.outline-button]="!checkSuperAdmin(data?.name)" [disabled]="checkSuperAdmin(data?.name)" (click)="goto(data?._id)">Edit</button>
            <button *appHasAnyPrivilege="'ROLE_DELETE'" class="outline-button more-dropdown" [ngClass]="checkSuperAdmin(data?.name) ? 'hidden' : 'block'" nz-button nz-dropdown [nzDropdownMenu]="menu"
                    nzPlacement="bottomCenter"><span nz-icon nzType="more" nzTheme="outline"></span></button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item
                    nz-popconfirm
                    [nzPopconfirmOverlayStyle]="{'width': '25rem'}"
                    [nzPopconfirmPlacement]="'left'"
                    nzPopconfirmTitle="{{(data.users > 0) ? 'As this role has already been assigned to a user or users, it cannot be deleted. Please try to delete after unassigned the role from the users.' : 'Do you really want to delete this role?'}}"
                    (nzOnConfirm)="confirm(data._id, (data.users > 0))"
                    nz-button
                    nzDanger
                    [ngClass]="checkSuperAdmin(data?.name) ? 'hidden' : 'block'"
                >Delete
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </td>
      </tr>
      </tbody>
    </nz-table>
  </div>
  <div [ngClass]="loading ? 'block' : 'hidden'">
    <app-table-skeleton-template [columnData]="skeletonTableColumns"></app-table-skeleton-template>
  </div>
</nz-card>

